// app/components/causeOfCalls/CauseTree.jsx
import React from 'react';
import { ChevronRight, Edit2, Trash2 } from 'lucide-react';

const CauseTree = ({ causes, expandedNodes, onToggleExpand, onEdit, onDelete }) => {
    const renderCauseNode = (cause, level = 0) => (
        <div key={cause.id}>
            <div
                className={`flex items-center p-2 hover:bg-gray-50 border-b`}
                style={{ paddingLeft: `${level * 2 + 1}rem` }}
            >
                <div className="flex-1 flex items-center">
                    {cause.has_children && (
                        <button
                            onClick={() => onToggleExpand(cause.id)}
                            className="mr-2 text-gray-500 hover:text-gray-700"
                        >
                            <ChevronRight
                                className={`w-4 h-4 transition-transform ${expandedNodes.has(cause.id) ? 'rotate-90' : ''
                                    }`}
                            />
                        </button>
                    )}
                    {!cause.has_children}

                    <div className="flex-1">
                        <div className="flex items-center gap-3">
                            <span className="font-medium text-gray-900">{cause.name}</span>
                            <span className="text-sm text-gray-500">({cause.code})</span>
                            <span className={`px-2 py-1 text-xs rounded-full ${cause.is_active !== false
                                    ? 'bg-green-100 text-green-800'
                                    : 'bg-red-100 text-red-800'
                                }`}>
                                {cause.is_active !== false ? 'Active' : 'Inactive'}
                            </span>
                        </div>
                        {cause.description && (
                            <p className="text-sm text-gray-500 mt-1">{cause.description}</p>
                        )}
                    </div>
                </div>

                <div className="flex gap-2">
                    <button
                        onClick={() => onEdit(cause)}
                        className="text-blue-600 hover:text-blue-800"
                    >
                        <Edit2 className="w-4 h-4" />
                    </button>
                    <button
                        onClick={() => onDelete(cause.id)}
                        className="text-red-600 hover:text-red-800"
                    >
                        <Trash2 className="w-4 h-4" />
                    </button>
                </div>
            </div>

            {expandedNodes.has(cause.id) && cause.children && (
                <div>
                    {cause.children.map(child => renderCauseNode(child, level + 1))}
                </div>
            )}
        </div>
    );

    return (
        <div className="overflow-x-auto mrgall">
            {causes.map(cause => renderCauseNode(cause))}
        </div>
    );
};

export default CauseTree;